import React from 'react';
import styled from 'styled-components';
import images from '_images';
import { _ } from '_locales';

const Container = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: 'column';
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
`;

const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 70%;
  max-width: 400px;
  max-height: 85%;
  background: #fff;
  border-radius: 10px;
`;

const RestartButton = styled.button`
  margin-bottom: 5px;
  margin-top: 5px;
  width: 85%;
  max-width: 300px;
  height: 6vh;
  justify-content: center;
  align-items: center;
  background-color: #00008B;
  color: white;
  border: none;
  border-radius: 8px;
`;

const ContinueButton = styled.button`
  margin-top: 5px;
  margin-bottom: 10px;
  width: 85%;
  max-width: 300px;
  height: 5vh;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #00008B;
  border: none;
`;

const TimeOutText = styled.h2`
  font-size: 20px;
  text-align: center;
`;

const TimeOutContext = styled.h2`
  font-size: 14px;
`;

const TimeOutImage = styled.img`
  height: 200px;
  margin-right: 3%;
  width: 200px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  display: flex;
  display: flex;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 5px;
  margin-right: 5px;
`;

const TimeOutModal = ({
  onClose,
  onRestart
}) => (
  <Container>
    <ModalContent>
      <CloseButton src={images.recycleRight.close} onClick={onClose} />
      <TimeOutText>
        {_('recycleRight.oops')}
      </TimeOutText>
      <TimeOutContext>
        {_('recycleRight.times_out')}
      </TimeOutContext>
      <TimeOutImage
        src={images.recycleRight.time_out}
      />
      <RestartButton onClick={onRestart}>
        {_('recycleRight.restart')}
      </RestartButton>
      <ContinueButton onClick={onClose}>
        {_('recycleRight.continue')}
      </ContinueButton>
    </ModalContent>
  </Container>
);

export default TimeOutModal;
